import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const InterestAssessmentStep = ({ formData, errors, onChange, onCheckboxChange }) => {
  const careerGoalOptions = [
    { value: 'medecine', label: 'Médecine et Santé' },
    { value: 'ingenierie', label: 'Ingénierie et Technologies' },
    { value: 'commerce', label: 'Commerce et Gestion' },
    { value: 'droit', label: 'Droit et Sciences Politiques' },
    { value: 'education', label: 'Éducation et Enseignement' },
    { value: 'arts', label: 'Arts et Création' },
    { value: 'agriculture', label: 'Agriculture et Environnement' },
    { value: 'communication', label: 'Communication et Médias' },
    { value: 'sciences-sociales', label: 'Sciences Sociales' },
    { value: 'tourisme', label: 'Tourisme et Hôtellerie' },
    { value: 'sport', label: 'Sport et Animation' },
    { value: 'pas-sur', label: 'Je ne suis pas encore sûr(e)' }
  ];

  const studyPreferenceOptions = [
    { value: 'theorique', label: 'Études Théoriques (Cours magistraux, recherche)' },
    { value: 'pratique', label: 'Études Pratiques (Travaux pratiques, stages)' },
    { value: 'mixte', label: 'Mélange Théorie et Pratique' }
  ];

  const studyDurationOptions = [
    { value: 'court', label: 'Court (2-3 ans - BTS, DUT)' },
    { value: 'moyen', label: 'Moyen (3-5 ans - Licence, Master)' },
    { value: 'long', label: 'Long (5+ ans - Doctorat, Médecine)' },
    { value: 'flexible', label: 'Je suis flexible' }
  ];

  const activityList = [
    { id: 'lecture', label: 'Lecture et Écriture' },
    { id: 'sport', label: 'Sport et Activités Physiques' },
    { id: 'musique', label: 'Musique et Chant' },
    { id: 'dessin', label: 'Dessin et Arts Visuels' },
    { id: 'informatique', label: 'Informatique et Programmation' },
    { id: 'sciences', label: 'Expériences Scientifiques' },
    { id: 'debat', label: 'Débats et Discussions' },
    { id: 'bricolage', label: 'Bricolage et Construction' },
    { id: 'cuisine', label: 'Cuisine et Pâtisserie' },
    { id: 'theatre', label: 'Théâtre et Expression' },
    { id: 'nature', label: 'Nature et Environnement' },
    { id: 'aide', label: 'Aide aux Autres et Bénévolat' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-blue-500 rounded-full flex items-center justify-center">
            <span className="text-white text-sm md:text-base lg:text-lg font-semibold">3</span>
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
              Centres d'Intérêt et Aspirations
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Aidez-nous à comprendre vos passions et vos objectifs de carrière.
            </p>
          </div>
        </div>
      </div>
      <Select
        label="Objectif de Carrière Principal"
        options={careerGoalOptions}
        value={formData?.careerGoal}
        onChange={(value) => onChange({ target: { name: 'careerGoal', value } })}
        placeholder="Que souhaitez-vous faire plus tard ?"
        description="Vous pouvez changer d'avis plus tard, c'est normal !"
        error={errors?.careerGoal}
        searchable
        required
      />
      <Select
        label="Type d'Études Préféré"
        options={studyPreferenceOptions}
        value={formData?.studyPreference}
        onChange={(value) => onChange({ target: { name: 'studyPreference', value } })}
        placeholder="Comment préférez-vous apprendre ?"
        error={errors?.studyPreference}
        required
      />
      <Select
        label="Durée d'Études Souhaitée"
        options={studyDurationOptions}
        value={formData?.studyDuration}
        onChange={(value) => onChange({ target: { name: 'studyDuration', value } })}
        placeholder="Combien de temps voulez-vous étudier ?"
        description="Cela nous aide à recommander des filières adaptées"
        error={errors?.studyDuration}
        required
      />
      <div>
        <CheckboxGroup 
          label="Activités Extra-Scolaires" 
          error={errors?.activities}
        >
          <p className="text-sm text-gray-600 mb-3 md:mb-4">
            Sélectionnez les activités que vous aimez faire pendant votre temps libre
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {activityList?.map((activity) => (
              <Checkbox
                key={activity?.id}
                label={activity?.label}
                checked={formData?.activities?.includes(activity?.id)}
                onChange={(e) => onCheckboxChange('activities', activity?.id, e?.target?.checked)}
              />
            ))}
          </div>
        </CheckboxGroup>
      </div>
    </div>
  );
};

export default InterestAssessmentStep;